import { combineReducer } from '../combineReducer';
import { } from './storeViewReducer.type';



export const storeViewReducers = {};

export default combineReducer(storeViewReducers);
